import axios from "axios";

const delZSearchSession = function (z_suche_modul) {
  const url = `/persis/main?fn=z_suche&action=ajax_session_clear&z_suche_modul=${z_suche_modul}`;
  return axios({
    method: "post",
    url: url
  });
};

export default {
  delZSearchSession
};
